/* validation.js — sanitize all user input, validate forms */

export function sanitize(input) {
  return input.trim().replace(/[<>]/g, "").slice(0, 500);
}

export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

export function validateRSVP(form) {
  const errors = {};
  if (!sanitize(form.firstName)) errors.firstName = "First name is required.";
  if (!sanitize(form.lastName)) errors.lastName = "Last name is required.";
  if (!isValidEmail(form.email))
    errors.email = "Please enter a valid email address.";
  if (!form.events)
    errors.events = "Please select which events you will attend.";
  return errors;
}

export function hasErrors(errors) {
  return Object.keys(errors).length > 0;
}
